import { useLocation } from 'react-router-dom';
import { DEFAULT_OG_IMAGE_PATH, SITE_ORIGIN, getPageSeo } from '../seo/site';

export default function SeoHead() {
  const { pathname } = useLocation();
  const seo = getPageSeo(pathname);
  const origin = typeof window !== 'undefined' ? window.location.origin : SITE_ORIGIN;
  const canonical = `${origin}${seo.path}`;
  const ogImage = `${origin}${DEFAULT_OG_IMAGE_PATH}`;
  const isIndexable = seo.robots.startsWith('index');

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="robots" content={seo.robots} />
      {isIndexable ? <link rel="canonical" href={canonical} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Contsuite" />
      <meta property="og:locale" content="es_AR" />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={ogImage} />
    </>
  );
}
